'use strict';

(function(global) {

  /**
   * Действия над табличным документом.
   *
   * @since 5.7.0
   */
  class SpreadsheetActions extends global.BaseActions {

    constructor(data) {
      super();
      this._settings = {};
      this._initAttributes(data);
    }
  }

  global.SpreadsheetActions = SpreadsheetActions;

})(window.Core.preview);